// extracted by mini-css-extract-plugin
export default {"wheelSelectorContainer":"styles_wheelSelectorContainer__pFIm3","iconContainer":"styles_iconContainer__hd+RE"};